var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 13.125C4.59375 13.125 3.75 13.9688 3.75 15C3.75 16.0312 4.59375 16.875 5.625 16.875C6.65625 16.875 7.5 16.0312 7.5 15C7.5 13.9688 6.65625 13.125 5.625 13.125ZM24.375 13.125C23.3438 13.125 22.5 13.9688 22.5 15C22.5 16.0312 23.3438 16.875 24.375 16.875C25.4062 16.875 26.25 16.0312 26.25 15C26.25 13.9688 25.4062 13.125 24.375 13.125ZM15 13.125C13.9688 13.125 13.125 13.9688 13.125 15C13.125 16.0312 13.9688 16.875 15 16.875C16.0312 16.875 16.875 16.0312 16.875 15C16.875 13.9688 16.0312 13.125 15 13.125Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.5334ece9afbf12b6007f1a66554bee9b.svg";
export { ForwardRef as ReactComponent };